import { TenantReadDto, VatRecordDto } from '../_generated/api/user-management'
import { buildNavigationLink } from '../tools/link'
import ApiModel from './ApiModel'
import { nullableDate } from './ApiLifeCycleModel'

export default class Organization extends ApiModel<TenantReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get name() {
        return this.data.name ?? ''
    }

    get associations() {
        return this.data.vatRecords ?? []
    }

    get profileLink() {
        return buildNavigationLink('organizations', this.id)
    }

    get archivedAt() {
        return nullableDate(this.data.archivedAt)
    }

    get isArchived() {
        return !!this.archivedAt
    }

    static isVatRecordValid(record: VatRecordDto) {
        const nameLength = record.name?.length
        const vatLength = record.vatNo?.length
        if (!(nameLength && vatLength)) return false
        return nameLength > 0 && vatLength > 0
    }

    static getEmptyVatRecord(): VatRecordDto {
        return { name: '', vatNo: '' }
    }
}
